import React from 'react';
import { TickMarkTransOIcon } from 'common/Icons';
import { Document, InvalidDocument, ALLOWED_FORMATS } from './types';

interface ExportMainContentProps {
  connectionStatus: string | null;
  validRecords: Document[];
  invalidRecords: InvalidDocument[];
}

const ExportMainContent: React.FC<ExportMainContentProps> = ({
  connectionStatus,
  validRecords,
  invalidRecords
}) => {
  if (connectionStatus === null) {
    return (
      <>
        <div className="d-flex justify-content-center" style={{ minHeight: '100px' }}>
          <div id="loading" />
        </div>
        <p className="text-center text-muted">Checking GruntWorx connection...</p>
      </>
    );
  }

  if (connectionStatus !== 'Active') {
    return (
      <div className="alert alert-warning">
        <strong>GruntWorx Connection Required</strong>
        <p className="mb-0 mt-2">
          GruntWorx integration is not active. Please configure your GruntWorx connection in the 
          Integration settings before exporting files.
        </p>
      </div>
    );
  }

  return (
    <>
      <div className="alert alert-primary mb-3 d-flex flex-column pr-4">
        <h6 className="mb-2">
          Export {validRecords.length} file(s) to GruntWorx
        </h6>
        
        {validRecords.length > 0 && (
          <div className="my-2">
            <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
              <div className="bg-light p-2 rounded">
                <table className="table table-sm table-borderless mb-0">
                  <tbody>
                    {validRecords.map((file) => (
                      <tr key={`valid-${file.uuid}`}>
                        <td className="small text-muted border-0 py-1">
                          {file.doc_name || 'Unknown filename'}
                        </td>
                        <td className="small border-0 py-1">
                          <TickMarkTransOIcon style={{ color: '#28a745', fontSize: '1rem' }} />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}

        <small className="mt-2">
          <strong>Note:</strong> Files will be automatically organized by Client ID.
        </small>

      </div>
      
      {invalidRecords.length > 0 && (
        <div className="border-left border-danger pl-3 mb-3" style={{ borderLeftWidth: '3px' }}>
          <p className="text-danger">Some files will not be exported.</p>
          <div className="mt-1">
            <small className="text-muted">
              {invalidRecords.length} file(s) will be skipped due to validation errors:
            </small>
          </div>
          <div className="mt-2">
            <div style={{ maxHeight: '150px', overflowY: 'auto' }}>
              <div className="bg-light p-2 rounded">
                <table className="table table-sm table-borderless mb-0">
                  <thead>
                    <tr>
                      <th className="small text-muted border-0">Filename</th>
                      <th className="small text-muted border-0">Error</th>
                    </tr>
                  </thead>
                  <tbody>
                    {invalidRecords.map((file) => (
                      <tr key={`invalid-${file.uuid}`}>
                        <td className="small text-muted border-0 py-1">
                          {file.doc_name || 'Unknown file'}
                        </td>
                        <td className="small text-danger border-0 py-1">
                          {file.invalidReason}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="mt-2">
              <small className="text-muted">
                <strong>Supported formats:</strong> {ALLOWED_FORMATS.join(', ')}
              </small>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ExportMainContent; 